// strokeWidth support number, or css borderWidth style string
// '1px'
// '2px 0px'
// '2px 0px 1px'
// '10px 10px 0px 1px'
export function resolveStrokeWidth(strokeWidth) {
  // Default values
  const defaultResult = {
    value: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  };

  // Handle number input
  if (typeof strokeWidth === 'number') {
    return {
      value: strokeWidth,
      top: strokeWidth,
      bottom: strokeWidth,
      left: strokeWidth,
      right: strokeWidth,
    };
  }

  // Handle invalid input
  if (typeof strokeWidth !== 'string') {
    return defaultResult;
  }

  // Parse string values
  const parts = strokeWidth.split(' ').map((part) => {
    const value = parseInt(part);
    return isNaN(value) ? 0 : value;
  });

  switch (parts.length) {
    case 1: {
      // Single value applies to all sides
      const value = parts[0];
      return {
        value,
        top: value,
        bottom: value,
        left: value,
        right: value,
      };
    }

    case 2: {
      // First value is vertical (top/bottom), second is horizontal (left/right)
      const [vertical, horizontal] = parts;
      return {
        value: Math.max(vertical, horizontal),
        top: vertical,
        bottom: vertical,
        left: horizontal,
        right: horizontal,
      };
    }
    case 3: {
      // Values are top, horizontal (left/right), bottom
      const [top, horizontal, bottom] = parts;
      return {
        value: Math.max(top, horizontal, bottom),
        top,
        right: horizontal,
        bottom,
        left: horizontal,
      };
    }

    case 4: {
      // Values are top, right, bottom, left in order
      const [top, right, bottom, left] = parts;
      return {
        value: Math.max(top, right, bottom, left),
        top,
        right,
        bottom,
        left,
      };
    }

    default:
      return defaultResult;
  }
}

const defaultStrokeColorsResult = {
  isEmpty: true,
  value: '',
  top: '',
  right: '',
  bottom: '',
  left: '',
};

// input css borderColor value string
// output parsed border colors with value and sides
export function resolveStrokeColor(color) {
  if (!color) return defaultStrokeColorsResult;
  if (color === 'none') return defaultStrokeColorsResult;

  // Split on spaces while preserving rgb/rgba values
  const parts = color.split(/\s+(?![^(]*\))/);

  switch (parts.length) {
    case 1: {
      // Single color applies to all sides
      const value = parts[0];
      return {
        value,
        top: value,
        right: value,
        bottom: value,
        left: value,
      };
    }

    case 2: {
      // First color is vertical (top/bottom), second is horizontal (left/right)
      const [vertical, horizontal] = parts;
      return {
        value: vertical,
        top: vertical,
        bottom: vertical,
        left: horizontal,
        right: horizontal,
      };
    }

    case 3: {
      // Colors are top, horizontal (left/right), bottom
      const [top, horizontal, bottom] = parts;
      return {
        value: top,
        top,
        right: horizontal,
        bottom,
        left: horizontal,
      };
    }

    case 4: {
      // Colors are top, right, bottom, left in order
      const [top, right, bottom, left] = parts;
      return {
        value: top,
        top,
        right,
        bottom,
        left,
      };
    }

    default:
      return defaultStrokeColorsResult;
  }
}
